module.exports = __webpack_public_path__ + "media/images/img-car-3-e2829d3f.png";